
/* esRealSync (Oct 6): keep the real Shopify cart identical to the SPA cart, built by the same esLines() esCheckout uses
   (packs consolidated, selling plans, line properties) plus the free scent ring at $45+ after discounts (Oct 14).
   Why: v2 mirrored each add into the real cart (for pixel add-to-cart events) but never removals or consolidation, and
   apps that read the real cart (Redo Checkout+, Shop Pay / Shop app cart sync, native /cart, Klaviyo restore) sent
   customers to checkout with a wrong cart: no gift, singles at single prices, removed items still in, some adds missing.
   Adds still go through /cart/add.js, so Shopify's product_added_to_cart event keeps firing for the pixel apps.
   esCheckout() stays the final authority (clear + rebuild) and is never run while a sync is in flight. */
(function(){
  if(typeof window.esLines!=='function'||typeof window.syncCart!=='function'||!window.cart)return;
  var OLDBAY={50566361678043:1,50566361710811:1};
  function giftIds(){var o={};Object.keys(window.__GIFTRING||{}).forEach(function(k){o[window.__GIFTRING[k]]=1});return o}
  var busy=false,dirty=false,timer=null,coPending=false,coActive=false,last=null;
  function isGift(it){return !!(giftIds()[it.variant_id]||OLDBAY[it.variant_id])}
  function isRedo(it){return it.sku==='x-redo'}
  function pk(props){
    if(!props)return '';
    var o=[];Object.keys(props).sort().forEach(function(k){var v=props[k];if(v!==null&&v!==undefined&&v!=='')o.push(k+'='+v)});
    return o.join('&');
  }
  function keyOf(id,plan,props){return id+'|'+(plan||'')+'|'+pk(props)}
  function post(u,b){return fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)}).then(function(r){return r.json()})}
  function getCart(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})}
  function desired(){
    var W={};
    if(!cart.items.length)return W;
    esLines().lines.forEach(function(l){
      var k=keyOf(l.id,l.plan,l.props);
      if(!W[k])W[k]={id:l.id,plan:l.plan,props:l.props,q:0};
      W[k].q+=l.quantity;
    });
    return W;
  }
  function gift(c){
    var gs=[],redo=0,gsum=0;
    c.items.forEach(function(it){if(isGift(it)){gs.push(it);gsum+=it.final_line_price}else if(isRedo(it))redo+=it.final_line_price});
    var tot=c.total_price-redo-gsum;
    var want=cart.items.length&&tot>=4500&&!window.__GIFTOFF;
    var vid=window.esGiftVariant?esGiftVariant():null;
    var u={},keep=null;
    gs.forEach(function(it){if(want&&!keep&&it.variant_id===vid){keep=it;if(it.quantity!==1)u[it.key]=1}else u[it.key]=0});
    var p=Object.keys(u).length?post('/cart/update.js',{updates:u}):Promise.resolve();
    if(want&&!keep&&vid)return p.then(function(){return post('/cart/add.js',{items:[{id:vid,quantity:1}]})});
    return p;
  }
  function run(){
    if(coActive)return;
    if(busy){dirty=true;return}
    busy=true;dirty=false;
    var W=desired();
    getCart().then(function(c){
      var upd={},has={},adds=[];
      c.items.forEach(function(it){
        if(isRedo(it)||isGift(it))return;
        var sp=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan&&it.selling_plan_allocation.selling_plan.id;
        var k=keyOf(it.variant_id,sp,it.properties);
        if(W[k]&&!has[k]){has[k]=1;if(it.quantity!==W[k].q)upd[it.key]=W[k].q}
        else upd[it.key]=0;
      });
      Object.keys(W).forEach(function(k){
        if(has[k])return;
        var w=W[k],o={id:w.id,quantity:w.q};
        if(w.plan)o.selling_plan=w.plan;
        if(w.props)o.properties=w.props;
        adds.push(o);
      });
      var p=Promise.resolve();
      if(Object.keys(upd).length)p=p.then(function(){return post('/cart/update.js',{updates:upd})});
      if(adds.length)p=p.then(function(){return post('/cart/add.js',{items:adds})});
      return p.then(getCart).then(gift);
    }).catch(function(){}).then(function(){
      busy=false;
      if(coPending){coPending=false;window.esCheckout();return}
      if(dirty){run();return}
      pending(false);
      try{if(window.esTrack&&esTrack.disc)esTrack.disc()}catch(e){}
    });
  }
  /* Redo's Checkout+ goes straight to /checkout with the real cart, so block it until the real cart has caught up */
  var pendT=null;
  function pending(on){
    var de=document.documentElement;clearTimeout(pendT);
    if(on){de.classList.add('es-cart-syncing');pendT=setTimeout(function(){de.classList.remove('es-cart-syncing')},8000)}
    else de.classList.remove('es-cart-syncing');
  }
  function schedule(){pending(true);clearTimeout(timer);timer=setTimeout(run,600)}
  var origSync=window.syncCart;
  window.syncCart=function(){
    var r=origSync.apply(this,arguments);
    try{var s=JSON.stringify(cart.items);if(s!==last){last=s;schedule()}}catch(e){}
    return r;
  };
  var origCO=window.esCheckout;
  window.esCheckout=function(){
    clearTimeout(timer);
    if(busy){coPending=true;return}
    coActive=true;
    /* esCheckout can bail without leaving the page (empty cart, unknown item, store declined): resume syncing */
    setTimeout(function(){coActive=false},10000);
    return origCO.apply(this,arguments);
  };
  /* bfcache: a shopper who backs out of checkout returns to a live page; let syncs run again */
  window.addEventListener('pageshow',function(){coActive=false});
  try{last=JSON.stringify(cart.items)}catch(e){}
  /* returning visitor with a saved SPA cart: the SPA cart is the truth, bring the real cart in line once */
  if(cart.items.length)schedule();
  window.esRealSync=run;
})();
